import React from 'react';
import { HeartPulse, RefreshCw } from 'lucide-react';

interface HealthSummaryProps {
  online: number;
  total: number;
  isLoading: boolean;
  hasError: boolean;
  isExpanded: boolean;
  onClick: () => void;
  onRefresh: () => void;
}

export const HealthSummary: React.FC<HealthSummaryProps> = ({
  online,
  total,
  isLoading,
  hasError,
  isExpanded,
  onClick,
  onRefresh,
}) => {
  const allOnline = online === total && total > 0;
  const hasIssues = online < total && total > 0;

  const handleRefreshClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRefresh();
  };

  return (
    <div className="abh-summary-container">
      <button
        className={`abh-summary ${isExpanded ? 'expanded' : ''} ${allOnline ? 'healthy' : hasIssues ? 'degraded' : ''}`}
        onClick={onClick}
        title="Click to view service health"
      >
        <HeartPulse size={12} className={`abh-summary-icon ${isLoading ? 'loading' : ''}`} />

        {hasError ? (
          <span className="abh-summary-status error">ERR</span>
        ) : total > 0 ? (
          <span className={`abh-summary-status ${allOnline ? 'healthy' : 'degraded'}`}>
            {online}/{total}
          </span>
        ) : (
          <span className="abh-summary-status loading">...</span>
        )}
      </button>

      <button
        className={`abh-summary-refresh ${isLoading ? 'loading' : ''}`}
        onClick={handleRefreshClick}
        disabled={isLoading}
        title="Refresh health status"
      >
        <RefreshCw size={12} className={isLoading ? 'spinning' : ''} />
      </button>
    </div>
  );
};
